import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useLogs } from "../context/LogContext";
import generateHMAC from "../utils/HMAC";
import generateDeviceId from "../utils/GenerateKey";
import { api } from "../utils/api";
import { loadString, saveString } from "../utils/storage";

const Home = () => {
  const { addLog } = useLogs();
  const navigate = useNavigate();
  const hasRunRef = useRef(false);

  useEffect(() => {
    // Only run once on mount
    if (hasRunRef.current) return;
    hasRunRef.current = true;

    const registerDevice = async () => {
      try {
        // Check if we already have the hash in localStorage to save time
        // Backward-compatible read: supports both raw string and JSON-stringified legacy value
        let deviceKeyHash = loadString("deviceKeyHash");
        console.log("deviceKeyHash", deviceKeyHash);
        if (!deviceKeyHash) {
          addLog("Generating device signature...");
          const deviceKeygen = await generateDeviceId();
          deviceKeyHash = await generateHMAC(deviceKeygen);
          // Store as plain string (avoid extra quotes; loadString remains backward-compatible)
          saveString("deviceKeyHash", deviceKeyHash);
        }

        addLog("TLS implementated");
        addLog("Connected to the server");
        addLog("SSL Certificate verified");
        addLog("API call to check if device is registered");
        addLog(`API Request Body: { 
            deviceKeyHash: ${deviceKeyHash},
          }`);

        const fcmToken = "dsd";
        const response = await api.post("/users/is-device-register", {
          deviceKeyHash,
          fcmToken,
        });
        console.log("response", response);

        // Store as plain string (avoid extra quotes like `"696a..."`)
        localStorage.setItem("userId", String(response.data.data.userId));

        const consentAccepted = sessionStorage.getItem("consentAccepted");
        const target = response.data.data.hasFaceData
          ? "/verify-scan"
          : "/scan";
        console.log("Navigating to:", target);

        // If device is already registered (has face data), skip consent and go to verify-scan
        if (response.data.data.hasFaceData) {
          sessionStorage.setItem("consentAccepted", "true"); // Auto-accept for registered devices
          return navigate("/verify-scan", { replace: true });
        }

        // For new users, check if consent was already given in this session
        if (consentAccepted) {
          if (target === "/scan") {
            sessionStorage.setItem("canAccessScan", "true");
          }
          return navigate(target, { replace: true });
        } else {
          return navigate("/consent", {
            state: { next: target },
            replace: true,
          });
        }
      } catch (err) {
        console.error("Error during device registration:", err);
        addLog("TLS implementated");
        addLog("Connected to the server");
        addLog("SSL Certificate verified");
        addLog("API call to check if device is registered");
        addLog(`API Error: Device not registered`);
      }
    };

    registerDevice();
  }, [navigate, addLog]); // guarded by hasRunRef, so safe to include addLog
  return (
    <div className="left-content">
      <h2>Welcome to the Home Page</h2>
      <button onClick={() => navigate("/consent")}>Register</button>
      {/* <button onClick={() => navigate("/login")}>Verification</button> */}
    </div>
  );
};

export default Home;
